module.exports = __webpack_public_path__ + "static/img/12.d068a9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/12.png
// module id = K6L7
// module chunks = 0